import { AUTH_LOCAL_STORAGE_TOKEN } from '../auth.service';

export function storageGetItem(key): string {
  try {
    return decodev1(localStorage.getItem(key));
  } catch (error) {
    return null;
  }
}

export function storageSetItem(key, value): void {
  localStorage.setItem(key, encodev1(value));
}

export function encodev1(value = ''): string {
  let padding = 0;
  value = reverse(btoa(reverse(value)));
  value = value.replace(/=/g, () => ++padding && '');
  return `v1:${value}:${padding}`;
}

export function decodev1(item = ''): string {
  if (!item.startsWith('v1:')) {
    return item;
  }
  let [, value, padding] = item.split(':'); // eslint-disable-line prefer-const
  for (let i = 0; i < parseInt(padding, 10); i++) {
    value = '=' + value;
  }
  return reverse(atob(reverse(value)));
}

export function reverse(str: string): string {
  return Array.from(str).reverse().join('');
}

/**
 * Use AuthService.isLoggedIn instead!
 * This does NOT indicate the user has a valid session, do not use this unless troubleshooting auth
 */
export function checkLocalStorageForAuth(): boolean {
  const pattern = /^@@auth0spajs@@/;
  return (
    Object.keys(localStorage).some((key) => pattern.test(key)) ||
    (localStorage.getItem(AUTH_LOCAL_STORAGE_TOKEN)?.length || 0) > 0
  );
}

/**
 * Use AuthService.logout() instead!
 * Not a safe log out method, this is intended to clear out any potentially corrupted auth state in local storage that could be causing login issues.
 */
export function scrubAuthFromLocalStorage(): void {
  const pattern = /^@@auth0spajs@@/;
  Object.keys(localStorage).forEach((key) => {
    if (pattern.test(key)) {
      localStorage.removeItem(key);
    }
  });
  localStorage.removeItem(AUTH_LOCAL_STORAGE_TOKEN);
}
